import { render, staticRenderFns } from "./WelcomeParchment.vue?vue&type=template&id=08511b4a&scoped=true&"
import script from "./WelcomeParchment.vue?vue&type=script&lang=js&"
export * from "./WelcomeParchment.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeParchment.vue?vue&type=style&index=0&id=08511b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08511b4a",
  null
  
)

export default component.exports